import { FacebookPixelTracker } from "./FacebookPixelTracker";
import { FacebookPixelTrackerMock } from "./FacebookPixelTrackerMock";
import { useMock } from "../utils/useMock";

export default useMock() ? FacebookPixelTrackerMock : FacebookPixelTracker;
